import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { 
  Button, 
  Box, 
  Typography, 
  Divider,
} from '@mui/material';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import SettingsIcon from '@mui/icons-material/Settings';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';

export default function Main() {
    const nav = useNavigate();
    const handleSelection = async(path) => {
        nav(path);
    }
    return(
        <Box
            sx={{
                marginTop: 1,
                display: 'flex',
                flexDirection: 'column',
                padding:1
            }}
        >
            
            <Typography component="h1" variant="h5">
              Select Module
            </Typography>
            
            <Divider sx={{minWidth:'100%'}}></Divider>

            <Box
                sx={{
                    display:'flex',
                    flexDirection:'row',
                    width: '100%',
                    height: '25%',
                    flexWrap: 'wrap',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                }}
            >
                <Button 
                    variant='contained' 
                    sx={{ 
                        borderInlineColor:'#fff', 
                        justifyContent: 'space-evenly',
                        border:2, 
                        borderRadius:2,
                        width: '40%',
                        margin: 2,
                        fontSize: '150%'
                    }} 
                    onClick={() => handleSelection('open')}
                >
                    Single & Batch Opening
                    <OpenInBrowserIcon fontSize='large'/>
                </Button>

                <Button 
                    variant='contained' 
                    sx={{ 
                        borderInlineColor:'#fff', 
                        justifyContent: 'space-evenly',
                        border:2, 
                        borderRadius:2,
                        width: '40%',
                        margin: 2,
                        fontSize: '150%'
                    }} 
                    onClick={() => handleSelection('close')}
                >
                    Batch Closing
                    <Inventory2Icon fontSize='large'/>
                </Button>

                <Button 
                    variant='contained' 
                    sx={{ 
                        borderInlineColor:'#fff', 
                        justifyContent: 'space-evenly',
                        border:2, 
                        borderRadius:2,
                        width: '40%',
                        margin: 2,
                        fontSize: '150%'
                    }} 
                    onClick={() => handleSelection('config')}
                >
                    Configuration
                    <SettingsIcon fontSize='large'/>
                </Button>
            </Box>
        </Box>
    );
}